import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils.js'
import ChatRecentUI from './ChatRecentUI.js'

class ChatRecentSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      userMessageList: null
    }
  }

  render() {
    return (
      <ChatRecentUI
        context={this.props.context}
        errorList={this.state.errorList}
        userMessageList={this.state.userMessageList}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getChats(context)
  }

  getChats(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chatMessages/statuses/recent`,
      cacheKey: CacheKeys.Chats('recent'),
      callback: this.getChatsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getChatsCallback = (response) => {
    this.setState({  userMessageList: response.userMessageList })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.Chats('recent'))
    if (noBusy === 'noBusy')
      this.getChats(context)
    else
      this.setState({ userMessageList: null, errorList: null },
        this.getChats(context)
      )
  }
}

export default ChatRecentSF
